import { Component } from '@theme/component';
class IpxMobilePurchase extends Component {
  requiredRefs = ['price', 'buy'];
  connectedCallback() {
    super.connectedCallback();
    const section = this.closest('.shopify-section');
    const details = section?.querySelector('.product-details');
    this.sync = () => {
      const form = document.getElementById(this.dataset.formId);
      const original = form?.querySelector('[ref="addToCartButton"]');
      const price = details?.querySelector('product-price .price');
      this.refs.buy.disabled = !original || original.disabled;
      if (price) this.refs.price.textContent = price.textContent;
      if (original) this.refs.buy.textContent = original.querySelector('.add-to-cart-text')?.textContent?.trim() || original.textContent.trim();
    };
    this.observer = new MutationObserver(this.sync);
    if (details) this.observer.observe(details, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled']});
    this.sync();
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    super.disconnectedCallback();
  }
}
if (!customElements.get('ipx-mobile-purchase')) customElements.define('ipx-mobile-purchase', IpxMobilePurchase);
